
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/press/[...slug]",
      function () {
        return require("private-next-pages/press/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/press/[...slug]"])
      });
    }
  